export default __webpack_public_path__ + "static/media/UY.fad38bae.svg";